import {getWebComponentLoader} from 'app/utils/initialize/getWebComponentLoader';

import {BranchDetailPageRedirectionLazy} from './lazy';

const KEY = 'gem-branch-detail-page-redirection';

export function defineBranchDetailPageRedirection(WebComponentLoader: ReturnType<typeof getWebComponentLoader>) {
    if (customElements.get(KEY)) {
        return;
    }

    customElements.define(
        KEY,
        class extends WebComponentLoader {
            reactLazyComponent = BranchDetailPageRedirectionLazy;
        },
    );
}
